import { ProcessState } from "./ProcessResponse";

export interface StartProcessRequest {
	definition_id: string;
	state?: ProcessState;
}